const pk10KeyNames = [
  '冠军龙',
  '冠军虎',
  '亚军龙',
  '亚军虎',
  '第三名龙',
  '第三名虎',
  '第四名龙',
  '第四名虎',
  '第五名龙',
  '第五名虎'
]

export const fieldList = {
  columnKeys() {
    const returnArray = new Array(10).fill()
    for (let i = 0; i < returnArray.length / 2; i += 1) {
      returnArray[2 * i] = {
        groupKey: `group${i + 1}_${returnArray.length - i}`,
        longHu: 'longHu_long',
        label: pk10KeyNames[2 * i]
      }
      returnArray[2 * i + 1] = {
        groupKey: `group${i + 1}_${returnArray.length - i}`,
        longHu: 'longHu_hu',
        label: pk10KeyNames[2 * i + 1]
      }
    }
    return returnArray
  }
}
